import React, { useState } from 'react';
import '../../styles.css';
import { firestore } from '../../Firebase';
import { withRouter } from 'react-router-dom';
import validator from 'validator'
import Axios from 'axios'



function StudentForm(props) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [schoolCode, setSchoolCode] = useState("");
    const [classCode, setClassCode] = useState("");
    const [role, setRole] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");


    const sendMessage = async (e) => {
        e.preventDefault();
        var username_data = []
        var email_data = []


        const previous_accounts = await firestore.collection("accounts").get()
        previous_accounts.forEach(doc => {
            username_data.push(doc.data().username)
            email_data.push(doc.data().email)
        })

        const password_details = await firestore.collection("security").doc("genesis").get()
        var classcode_db = password_details.data().classcode
        var schoolcode_db = password_details.data().schoolcode


        var errortext = "";
        if (password2 !== password) {
            errortext += "passwords do not match. "
        }
        if (!validator.isEmail(email)) {
            errortext += "email is invalid. "
        }
        if (name === "") {
            errortext += "name is empty. "
        }
        if (password === "") {
            errortext += "password is empty. "
        }
        if (username_data.includes(username)) {
            errortext += "username is already taken. "
        }
        if (email_data.includes(email)) {
            errortext += "an account already exists with this email. "
        }

        if (role === "") {
            errortext += "please select role. "
        }

        if (schoolCode !== schoolcode_db) {
            errortext += "invalid schoolcode. "
        }

        if (!(classcode_db.includes(classCode)) && role === "student") {
            errortext += "invalid classcode. "
        }


        if (errortext !== "") {
            alert(errortext)
        } else {
            alert("Account awaiting admin verification")
            const messageRef = firestore.collection('accounts');
            await messageRef.add({
                classcode: classCode.trim(),
                email: email.trim(),
                name: name.trim(),
                username: username.trim(),
                password: password.trim(),
                role: role.trim(),
                schoolcode: schoolCode.trim(),
                last_8: [],
                smt: [],
                pnc: [],
                krb: [],
                jfg: [],
                hdw: [],
                vly: [],
                verified: "false",
            });

            if (role == "student") {
                var teacher_email;
                const matches = await firestore.collection('accounts').where('role', '==', 'teacher').where('classcode', '==', classCode.trim()).get()
                matches.docs.forEach((doc) => {
                    teacher_email = doc.data().email
                })


                var destTeacher = "?dest=" + teacher_email
                var subjectTeacher = "&subject=student awaiting verification"
                var messageTeacher = "&message=Hi, " + "your student " + name.trim() + " is awaiting account verification. Please verify or deny their account from the verification management section"
                var path = "https://us-central1-dyslexia-d9e5d.cloudfunctions.net/sendMail"
                Axios.get(path + destTeacher + subjectTeacher + messageTeacher)
            }
            var destAdmin = "?dest=" + "benkwek@genesisschool.com.sg"
            var subjectAdmin = "&subject=decodeLabs account waiting for verification"
            var messageAdmin = "&message=Hi Ben," + name.trim() + " is awaiting account verification. Please verify or deny their account from the verification management section"
            var path = "https://us-central1-dyslexia-d9e5d.cloudfunctions.net/sendMail"
            Axios.get(path + destAdmin + subjectAdmin + messageAdmin)

            var dest = "?dest=" + email.trim()
            var subject = "&subject=decodeLabs account waiting for verification"
            var message = "&message=Hi " + name.trim() + ", your account is waiting for verification. Please contact your teacher to expedite the process "
            var path = "https://us-central1-dyslexia-d9e5d.cloudfunctions.net/sendMail"
            Axios.get(path + dest + subject + message)


            props.history.push('/');

        }
    }

    return (
        <div className='signupFormDiv'>
            <b className='titleText' style={{ marginTop: 50 }}>Account Details</b>
            <form className='signupForm' onSubmit={sendMessage}>
                <label for='lastName' className='signupFormLabel'>Full Name</label><br />
                <input value={name} onChange={(e) => setName(e.target.value)} type='text' id='lastName' name='lastName' className='signupFormTextField'></input><br />
                <label for='email' className='signupFormLabel'>Email</label><br />
                <input value={email} onChange={(e) => setEmail(e.target.value)} type='text' id='email' name='email' className='signupFormTextField'></input><br />
                <label for='userName' className='signupFormLabel'>Username</label><br />
                <input value={username} onChange={(e) => setUsername(e.target.value)} type='text' id='userName' name='userName' className='signupFormTextField'></input><br />
                <label for='password' className='signupFormLabel'>Set password</label><br />
                <input value={password} onChange={(e) => setPassword(e.target.value)} type='password' id='password' name='password' className='signupFormTextField'></input><br />
                <label for='password2' className='signupFormLabel'>Confirm password</label><br />
                <input value={password2} onChange={(e) => setPassword2(e.target.value)} type='password' id='password2' name='password2' className='signupFormTextField'></input><br />
                <label for='schoolName' className='signupFormLabel'>School code</label><br />
                <input value={schoolCode} onChange={(e) => setSchoolCode(e.target.value)} type='text' id='schoolName' name='schoolName' className='signupFormTextField'></input><br />
                <label for='classCode' className='signupFormLabel'>Class code</label><br />
                <input value={classCode} onChange={(e) => setClassCode(e.target.value)} type='text' id='classCode' name='classCode' className='signupFormTextField'></input><br />
                <label for='role' className='signupFormLabel'>Who are you?</label><br />
                <select value={role} onChange={(e) => setRole(e.target.value)} id='role' name='role' className='signupDropDown' style={{ marginBottom: 50, marginTop: 10 }}>
                    <option value='null'>-Select Role-</option>
                    <option value='teacher'>Teacher</option>
                    <option value='student'>Student</option>
                </select><br />
                <div className='submitArea'><input type='submit' id='signupSubmitButton' name='signupSubmit' className='signupFormSubmitButton'></input></div><br />
            </form>
        </div>
    );
}

export default withRouter(StudentForm);